import React from 'react';
import PageTopButton from '@components/common/pageTopButton';
import SkillPositionList from '@components/phs/test/skillPositionList';
import JobPositionList from '@components/phs/test/jobPositionList';
import PhsBanner from '@components/phs/test/phsBanner';
import ContentsList from '@components/phs/test/contentsList';
import { useDchampsInfo, useDhampsFinalsCheck } from '@repository/dchamps/useDchamps';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { DChampsToDoArea, DchampsEventBanner, DchampsFinalJoin } from './dChampsContents';
import { EventUserInfoArea, UserInfoArea } from './userInfoArea';
import RankChart from './dChampsContents/rankChart';
import { DchampsEventType } from '@domain/constant/dchamps/eventType';
import classnames from 'classnames/bind';
import styles from './phsGate.module.scss';
const cx = classnames.bind(styles);

const PhsNoEventGate = () => {
  return (
    <div className={cx('phsGateArea')}>
      <div className={cx('phsGateInner')}>
        {/* 유저 정보, 서비스 영역 */}
        <UserInfoArea />

        {/* 기술스택 활용 포지션 영역 */}
        <SkillPositionList />

        {/* 직무별 포지션 영역 */}
        <JobPositionList />

        {/* 개발자검사 홍보 배너 영역 */}
        <PhsBanner />

        {/* 정보를 잡다(디챔스 콘텐츠) 영역 */}
        <ContentsList />
      </div>

      {/* 페이지 Top 버튼 영역 */}
      <PageTopButton />
    </div>
  );
};

const PhsEventGate = () => {
  return (
    <>
      <DchampsEventBanner />

      <div className={cx('phsGateArea')}>
        <div className={cx('phsGateInner', 'event')}>
          {/* finalJoin 영역*/}
          <DchampsFinalJoin />

          {/* 유저 정보, 서비스 영역 */}
          <EventUserInfoArea />

          {/*디챔스 등급 확인 & 프로필 입력하기 영역 */}
          <DChampsToDoArea />

          {/*개구검 랭크 차트 */}
          {<RankChart />}

          {/* 기술스택 활용 포지션 영역 */}
          <SkillPositionList />

          {/* 직무별 포지션 영역 */}
          <JobPositionList />

          {/* 개발자검사 홍보 배너 영역 */}
          <PhsBanner />

          {/* 정보를 잡다(디챔스 콘텐츠) 영역 */}
          <ContentsList />
        </div>

        {/* 페이지 Top 버튼 영역 */}
        <PageTopButton />
      </div>

      {/* <DchampsBottomBanner /> */}
    </>
  );
};

const PhsGate = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { data: dchampsInfoData } = useDchampsInfo();
  const eventType = dchampsInfoData?.progressFinal?.eventType;
  const { data: isFinalist } = useDhampsFinalsCheck(isLogin && !!eventType, eventType as DchampsEventType);
  const onlyFinalistJoin = dchampsInfoData?.progressFinal && isFinalist;
  //디챔스 예선이 진행중이거나, 본선 진출자이면 이벤트 페이지 보여줌.
  const isVisible = dchampsInfoData?.progressQualify || onlyFinalistJoin;
  return isVisible ? <PhsEventGate /> : <PhsNoEventGate />;
};

export default PhsGate;
